import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="bg-[#F5F1EB] py-24 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          <div className="lg:pr-8">
            <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-6">/ About This Guide</p>
            <h2 className="font-cormorant text-5xl md:text-6xl text-[#1A1A18] font-light leading-tight mb-8">
              About Highlands NC<br />
              <em className="italic">Cabin Guide</em>
            </h2>
            <p className="text-[#5C5850] font-jost text-base leading-relaxed mb-5">
              This site is a curated guide to <Link to="/cabins-in-highlands-nc" className="text-[#2D4A3E] underline underline-offset-2 hover:text-[#C9A96E] transition-colors">cabins in Highlands, North Carolina</Link>, helping visitors discover the best places to stay near waterfalls, hiking trails, and downtown Highlands.
            </p>
            <p className="text-[#5C5850] font-jost text-base leading-relaxed mb-5">
              From <Link to="/best-luxury-cabins" className="text-[#2D4A3E] underline underline-offset-2 hover:text-[#C9A96E] transition-colors">luxury cabins</Link> to <Link to="/pet-friendly-cabins-highlands-nc" className="text-[#2D4A3E] underline underline-offset-2 hover:text-[#C9A96E] transition-colors">pet-friendly stays</Link> and <Link to="/cabins-near-glen-falls-highlands-nc" className="text-[#2D4A3E] underline underline-offset-2 hover:text-[#C9A96E] transition-colors">cabins near Glen Falls waterfall</Link>, the goal is to provide a helpful, unbiased resource for travelers exploring the Highlands area.
            </p>
            <p className="text-[#5C5850] font-jost text-base leading-relaxed mb-10">
              Glen Falls Luxury Cabin in Highlands, NC is one of the highly rated options featured here — known for its location near one of the area&apos;s most popular waterfalls and consistently recognized as a Guest Favorite on Airbnb.
            </p>

            <div className="flex flex-wrap gap-4">
              <Link
                to="/best-luxury-cabins"
                className="inline-flex items-center gap-2 bg-[#2D4A3E] text-white text-xs tracking-[0.2em] uppercase font-jost px-8 py-3.5 rounded-full hover:bg-[#1E3329] transition-colors cursor-pointer whitespace-nowrap"
              >
                Browse Cabins
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line" />
                </div>
              </Link>
              <Link
                to="/things-to-do"
                className="inline-flex items-center gap-2 border border-[#2D4A3E] text-[#2D4A3E] text-xs tracking-[0.2em] uppercase font-jost px-8 py-3.5 rounded-full hover:bg-[#2D4A3E] hover:text-white transition-all cursor-pointer whitespace-nowrap"
              >
                Things to Do in Highlands NC
              </Link>
            </div>
          </div>

          <div className="relative">
            <div className="w-full h-[460px] overflow-hidden rounded-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/590d9790f65d551f8788fc73b7603e22.jpg"
                alt="Glen Falls waterfall near Highlands, North Carolina"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-2xl max-w-[220px]">
              <div className="flex items-center gap-1 mb-2">
                {[1,2,3,4,5].map((s) => (
                  <div key={s} className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-star-fill text-[#C9A96E] text-xs" />
                  </div>
                ))}
              </div>
              <p className="font-cormorant text-xl text-[#1A1A18] font-medium leading-snug mb-1">Guest Favorite</p>
              <p className="text-[#9C9890] text-xs font-jost leading-snug">Glen Falls Luxury Cabin — Airbnb</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
